import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get('/health');
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="header">
        <h1>Dashboard</h1>
      </div>
      <div className="container">
        <Link to="/">
          <button className="btn">Back to Home</button>
        </Link>

        <div className="card">
          <h2>API Status</h2>
          {loading && <p>Loading...</p>}
          {error && <p style={{ color: 'red' }}>Error: {error}</p>}
          {data && (
            <div>
              <p><strong>Status:</strong> {data.status}</p>
              <p><strong>Message:</strong> {data.message}</p>
            </div>
          )}
          <button className="btn" onClick={fetchData} disabled={loading}>
            Refresh
          </button>
        </div>

        <div className="card">
          <h2>AWS Services</h2>
          <p>Integrated AWS services will appear here.</p>
          <ul>
            <li>S3 - File Storage</li>
            <li>DynamoDB - NoSQL Database</li>
            <li>Lambda - Serverless Functions</li>
            <li>Cognito - Authentication</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
